export enum MarkAsPaidWithoutFinancingPermissions {
  ViewInstruments = 'view_documents',
  ViewInstrumentDetails = 'view_instrument_details',
  ViewInstrumentAttachments = 'view_instrument_attachments',
  MarkInstrumentsAsPaid = 'mark_instruments_as_paid',
}
